export const CLEAR_TO_INITIAL = 'CLEAR_TO_INITIAL';
export const FAIL_LAST_ACTIVE_STEP = 'FAIL_LAST_ACTIVE_STEP';
export const UPDATE_STEP_PROGRESS = 'UPDATE_STEP_PROGRESS';
export const SET_VISIBILITY = 'SET_VISIBILITY';
